import React, { useState } from 'react';
import { ConfirmationModalProps } from './types';
import Modal from '../../design-system/components/atoms/modal/modal';
import { InfoCircle } from '../../svg/info-circle';
import Icon from '../../design-system/components/atoms/icon/icon';
import Checkbox from '../../design-system/components/atoms/checkbox';

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  show,
  onClose,
  titleContent = '',
  hideHeader = false,
  hideFooter = false,
  showCloseIcon = false,
  CustomHeaderIcon,
  customClassName,
  customHeaderText = '',
  CustomContent = '',
  onSubmit = () => {},
  submitButtonClassName,
  showCheckbox = false,
}) => {
  const [isChecked, setIsChecked] = useState(false);

  return (
    <Modal
      show={show}
      onClose={onClose}
      onHide={() => {}}
      onSubmit={() => onSubmit(isChecked)}
      showCloseIcon={showCloseIcon}
      className={customClassName || 'confirmation-modal'}
      submitButtonText="Yes"
      submitButtonClassName={submitButtonClassName}
      titleContent={titleContent}
      hideHeader={hideHeader}
      hideFooter={hideFooter}
    >
      <div className="confirmation-modal-header-container">
        <span>
          {CustomHeaderIcon || <InfoCircle className="info-circle-icon" />}
        </span>
        <span className="confirmation-modal-custom-text">
          {customHeaderText}
        </span>
      </div>
      <div className="confirmation-modal-body-container">
        <span>
          {CustomContent ||
            'This note will no longer be visible to your organisation. Only you will have access to it. Would you like to make it private?'}
        </span>
        {showCheckbox && (
          <div>
            <Checkbox
              id="confirmation-checkbox"
              label="Remove this email and all replies in the thread."
              checked={isChecked}
              onChange={(checked) => setIsChecked(checked)}
            />
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
